goog.module('yext.developerapps.salesforcereview.AddPropertyDialog');
goog.module.declareLegacyNamespace();

const DialogView = goog.require('yext.apps.common.DialogView');
const routes = goog.require('yext.developerapps.routes');

/**
 * @constructor
 */
const AddPropertyDialog = function($ctxt) {
  this.$ctxt = $ctxt.find('.js-dialog');
  this.onSave = function() {};
  this.addFieldDialog = new DialogView(this.$ctxt);
  this.$label = this.$ctxt.find('input[name=label]');
  this.$save = this.$ctxt.find('.js-save-property-btn');
};

AddPropertyDialog.prototype.init = function() {
  this.addFieldDialog.init();
  this.bindSave();
  this.bindUpdate();
};

AddPropertyDialog.prototype.setOnSave = function(func) {
  this.onSave = func;
};

AddPropertyDialog.prototype.show = function() {
  this.addFieldDialog.show();
};

AddPropertyDialog.prototype.bindSave = function() {
  var dialog = this;
  this.$save.on('click', function() {
    if (dialog._validateFields()) {
      var input = {
        'fieldName': dialog.$label.val(),
      };
      $.ajax({
        method: 'POST',
        ContentType: 'application/json',
        data: input,
        url: routes.SalesforceReviewGen.saveNewField(),
      }).done(function(data) {
        if (data['error']) {
          dialog._showError(data['error']);
          return;
        }
        dialog.onSave(data);
        dialog.addFieldDialog.hide();
      });
    }
  });
};

AddPropertyDialog.prototype.bindUpdate = function() {
  this.$label.on('change', function() {
    $(this).removeClass('error');
    $(this).closest('.js-field').find('.js-field-error').hide();
  });
};

AddPropertyDialog.prototype._validateFields = function() {
  if (this.$label.val().trim() == '') {
    this._showError('You must provide a label');
    return false;
  }
  return true;
};

AddPropertyDialog.prototype._showError = function(error) {
  this.$label.addClass('error');
  this.$label.closest('.js-field').find('.js-field-error').text(error).show();
};

exports = AddPropertyDialog;
